import * as React from 'react'
import { graphql } from 'gatsby'

import SidebarLayout from '../uglib_components/sidebarLayout'

import Sidebar from '../uglib_components/sidebar'
import SidebarMenu from '../uglib_components/sidebarMenu'

const UserExperienceReportPage = ( {location, data} ) => {
	const node = data.node;
	const title = node.title;

	// about/about-library/assessment-user-experience/ux-library/library-print-collections-ux-study

	const breadcrumbs = [
		{ 
			url: "",
			title: "About",
		},
		{ 
			url: "/about/about-library",
			title: "About the Library",
		},
        { 
			url: "/about/about-library/assessment-user-experience",
			title: "Assessment & User Experience",
		},
		{ 
			url: "/about/about-library/assessment-user-experience/ux-library",
			title: "UX in the Library",
		}
	]

	const sidebar = <>
		<Sidebar>
			<SidebarMenu url="/about/about-library/assessment-user-experience/ux-library" />
		</Sidebar>
	</>;

	let body = null;
	if (node.body !== null) {
		body = <>
			<div dangerouslySetInnerHTML={{__html:node.body.processed}}/>
		</>
	}

	let link = null;
	if (node.field_ux_link !== null) {
		link = <>
			<div className="text-center">
				<a className="btn btn-primary text-center" href={node.field_ux_link.uri}>Link to {node.title}</a>
			</div>
		</>
	}

	return (
		<SidebarLayout breadcrumbs={breadcrumbs} sidebar={sidebar} title={title} bodyClass='oral-history'>

			{body}
			
			{link}
			
		</SidebarLayout>
    );
}

export const query = graphql`
  	query ($id: String) {
		node:   nodeUserExperienceReport(id: {eq: $id}) {
			field_ux_short_description
			field_ux_year_of_study
			path {
			  	alias
			}
			title
			field_ux_link {
			  	uri
			}
			body {
				processed
			}
			id
		}
		
  	}
`

export default UserExperienceReportPage